import { Directive, ElementRef, AfterViewInit } from "@angular/core";
import { IonSearchbar } from "@ionic/angular";

@Directive({
  selector: '[autoFocusSearchbar]',
  standalone: true,
})
export class AutoFocusSearchbarDirective implements AfterViewInit {
  constructor(private readonly el: ElementRef<IonSearchbar>) {}

  ngAfterViewInit() {
    setTimeout(() => {
      (this.el.nativeElement as any).setFocus?.();
    });
  }
}
